import script from "./WordpressBackendApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordpressBackendApp.vue?vue&type=script&lang=ts&setup=true"

import "./WordpressBackendApp.vue?vue&type=style&index=0&id=04af6d65&lang=scss"

const __exports__ = script;

export default __exports__